module.exports = __webpack_public_path__ + "img/default-nav-subnav-mitsu.04efbbf3.png";